import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { Formik, FormikConfig, FormikValues } from 'formik'
import { SidebarHeader } from './SidebarHeader'
import { SidebarContent } from './SidebarContent'
import { SidebarFooter } from './SidebarFooter'
import { useBulkActionContext } from '../BulkActionContext'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'

export type SidebarProps<Values extends FormikValues> = FormikConfig<Values> & {
  title: string
  children: React.ReactNode
  saveDisabled?: boolean
  titleSx?: React.CSSProperties
}

export function Sidebar<Values extends FormikValues>(
  props: SidebarProps<Values>,
) {
  const { title, children, saveDisabled, titleSx, ...rest } = props

  const {
    dispatch,
    state: { isValidating: rowsValidating, errors },
    selectedRows,
  } = useBulkActionContext()

  const onClose = React.useCallback(
    () => dispatch({ type: 'setActive' }),
    [dispatch],
  )

  const theme = useTheme()

  return (
    <Formik<Values> {...rest}>
      {({ submitForm, isValid, isValidating }) => (
        <Box
          width="25%"
          minWidth="400px"
          display="flex"
          flexDirection="column"
          overflow="hidden"
        >
          <SidebarHeader titleSx={titleSx} title={title} onClose={onClose} />

          <Divider />

          <SidebarContent>{children}</SidebarContent>

          <Typography style={{ padding: theme.spacing(1), fontSize: '12px' }}>
            *Notifications are not sent for bulk updates to avoid excessive
            emails
          </Typography>
          <Divider />
          <SidebarFooter
            onCancel={onClose}
            onSave={submitForm}
            saveDisabled={
              saveDisabled ??
              (!isValid ||
                isValidating ||
                rowsValidating ||
                selectedRows.length === errors.size)
            }
          />
        </Box>
      )}
    </Formik>
  )
}
